import React from 'react';
import type { TechnicianJobCard } from '../api/types';
import { CardTone, cardStatus } from '../utils/technician';

const TONE_CLASS: Record<CardTone, string> = {
  gray: 'bg-gray-100 text-gray-700',
  blue: 'bg-blue-100 text-blue-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
};

/** Status badge of a technician job card. */
export function TechnicianStatusBadge({ card, userId }: { card: Pick<TechnicianJobCard, 'status' | 'openTimeEntries'>; userId?: string }) {
  const { label, tone } = cardStatus(card, userId);
  return <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${TONE_CLASS[tone]}`}>{label}</span>;
}
